import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Header from './header';
import Footer from './footer';

const PaymentC = () => {
  const sectionStyle = {
    marginBottom: '26px',
    paddingBottom: '22px',
    borderBottom: '1px solid #eef1f5',
  };

  const headingStyle = {
    fontSize: '19px',
    fontWeight: '700',
    color: '#172033',
    marginBottom: '9px',
    lineHeight: '1.5',
  };

  const paragraphStyle = {
    fontSize: '15px',
    lineHeight: '1.8',
    color: '#667085',
    marginBottom: '0',
  };

  return (
    <div
      id="payment-terms"
      style={{
        background: '#f6f8fc',
        minHeight: '100vh',
      }}
    >
      <Header />

      {/* Hero Section */}
      <div
        style={{
          background:
            'linear-gradient(135deg, #0d6efd 0%, #084298 100%)',
          padding: '55px 20px 70px',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <Container>
          <div
            style={{
              maxWidth: '900px',
              margin: '0 auto',
            }}
          >
            <div
              style={{
                width: '60px',
                height: '60px',
                borderRadius: '16px',
                background: 'rgba(255,255,255,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 18px',
                fontSize: '28px',
                fontWeight: '700',
              }}
            >
              ₹
            </div>

            <h1
              style={{
                fontSize: 'clamp(28px, 5vw, 44px)',
                fontWeight: '800',
                lineHeight: '1.2',
                marginBottom: '14px',
                letterSpacing: '-0.5px',
              }}
            >
              Payment Terms & Conditions / Refund & Cancellation Policy
            </h1>

            <p
              style={{
                fontSize: '16px',
                lineHeight: '1.7',
                opacity: 0.9,
                margin: 0,
              }}
            >
              Please review our payment, refund and cancellation policies
              carefully.
            </p>
          </div>
        </Container>
      </div>

      <Container
        style={{
          marginTop: '-35px',
          position: 'relative',
          zIndex: 2,
          paddingBottom: '55px',
        }}
      >
        {/* Payment Terms Header */}
        <Row className="mb-4">
          <Col md={10} lg={9} className="mx-auto">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
              }}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '13px',
                  background: '#eaf2ff',
                  color: '#0d6efd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                  fontWeight: '800',
                  flexShrink: 0,
                }}
              >
                01
              </div>

              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: '26px',
                    fontWeight: '750',
                    color: '#172033',
                  }}
                >
                  Payment Related Terms & Conditions
                </h2>

                <p
                  style={{
                    margin: '4px 0 0',
                    color: '#98a2b3',
                    fontSize: '14px',
                  }}
                >
                  Important information regarding online payments
                </p>
              </div>
            </div>
          </Col>
        </Row>

        {/* Payment Terms Card */}
        <Row>
          <Col md={10} lg={9} className="mx-auto">
            <Card
              style={{
                border: 'none',
                borderRadius: '18px',
                overflow: 'hidden',
                boxShadow: '0 12px 40px rgba(16, 24, 40, 0.08)',
              }}
            >
              <Card.Body
                style={{
                  padding: 'clamp(25px, 5vw, 50px)',
                }}
              >
                {/* Validity */}
                <div style={sectionStyle}>
                  <h3 style={headingStyle}>
                    <span style={{ color: '#0d6efd' }}>01.</span> Validity
                  </h3>

                  <p style={paragraphStyle}>
                    <strong style={{ color: '#344054' }}>Validity:</strong>{' '}
                    Online mock test series purchased on this website are valid
                    for one year from the date of enrollment. No extensions or
                    refunds will be provided after this period.
                  </p>
                </div>

                {/* Test Content Ownership */}
                <div style={sectionStyle}>
                  <h3 style={headingStyle}>
                    <span style={{ color: '#0d6efd' }}>02.</span>{' '}
                    Test Content Ownership
                  </h3>

                  <p style={paragraphStyle}>
                    <strong style={{ color: '#344054' }}>
                      Test Content Ownership:
                    </strong>{' '}
                    All test materials, including questions, answers, and
                    explanations, are copyrighted by ErwaToday.in and cannot be
                    reproduced or distributed without permission.
                  </p>
                </div>

                {/* Conduct Policy */}
                <div style={sectionStyle}>
                  <h3 style={headingStyle}>
                    <span style={{ color: '#0d6efd' }}>03.</span>{' '}
                    Conduct Policy
                  </h3>

                  <p style={paragraphStyle}>
                    <strong style={{ color: '#344054' }}>
                      Conduct Policy:
                    </strong>{' '}
                    Any fraudulent activity or attempt to cheat in the test
                    series will result in immediate termination of access
                    without a refund.
                  </p>
                </div>

                {/* Technical Issues */}
                <div style={sectionStyle}>
                  <h3 style={headingStyle}>
                    <span style={{ color: '#0d6efd' }}>04.</span>{' '}
                    Technical Issues
                  </h3>

                  <p style={paragraphStyle}>
                    <strong style={{ color: '#344054' }}>
                      Technical Issues:
                    </strong>{' '}
                    While we ensure a seamless experience, we are not liable
                    for unexpected technical difficulties such as server
                    downtime or connectivity issues.
                  </p>
                </div>

                {/* Modifications */}
                <div style={sectionStyle}>
                  <h3 style={headingStyle}>
                    <span style={{ color: '#0d6efd' }}>05.</span>{' '}
                    Modifications
                  </h3>

                  <p style={paragraphStyle}>
                    <strong style={{ color: '#344054' }}>
                      Modifications:
                    </strong>{' '}
                    We reserve the right to update test content, format, and
                    structure without prior notice.
                  </p>
                </div>

                {/* Access Termination */}
                <div
                  style={{
                    marginBottom: 0,
                  }}
                >
                  <h3 style={headingStyle}>
                    <span style={{ color: '#0d6efd' }}>06.</span>{' '}
                    Access Termination
                  </h3>

                  <p style={paragraphStyle}>
                    <strong style={{ color: '#344054' }}>
                      Access Termination:
                    </strong>{' '}
                    Violation of these terms may lead to termination of access
                    without prior notice or refund.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Refund Section Heading */}
        <Row
          style={{
            marginTop: '55px',
            marginBottom: '25px',
          }}
        >
          <Col md={10} lg={9} className="mx-auto">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
              }}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '13px',
                  background: '#eaf8f0',
                  color: '#198754',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                  fontWeight: '800',
                  flexShrink: 0,
                }}
              >
                02
              </div>

              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: '26px',
                    fontWeight: '750',
                    color: '#172033',
                  }}
                >
                  Refund & Cancellation Policy
                </h2>

                <p
                  style={{
                    margin: '4px 0 0',
                    color: '#98a2b3',
                    fontSize: '14px',
                  }}
                >
                  Information about refunds and transaction cancellations
                </p>
              </div>
            </div>
          </Col>
        </Row>

        {/* Refund Card */}
        <Row>
          <Col md={10} lg={9} className="mx-auto">
            <Card
              style={{
                border: 'none',
                borderRadius: '18px',
                overflow: 'hidden',
                boxShadow: '0 12px 40px rgba(16, 24, 40, 0.08)',
              }}
            >
              <Card.Body
                style={{
                  padding: 'clamp(25px, 5vw, 50px)',
                }}
              >
                {/* Refund Policy */}
                <div style={sectionStyle}>
                  <h3 style={headingStyle}>
                    <span style={{ color: '#198754' }}>01.</span>{' '}
                    Refund Policy:
                  </h3>

                  <p style={paragraphStyle}>
                    Refunds will only be issued for unsuccessful transactions
                    or unauthorized payments. The amount will be refunded
                    within 5-7 business days via the original payment method.
                  </p>
                </div>

                {/* Cancellation Policy */}
                <div
                  style={{
                    marginBottom: '25px',
                    paddingBottom: '22px',
                    borderBottom: '1px solid #eef1f5',
                  }}
                >
                  <h3 style={headingStyle}>
                    <span style={{ color: '#198754' }}>02.</span>{' '}
                    Cancellation Policy:
                  </h3>

                  <p style={paragraphStyle}>
                    Users can cancel their transactions within 24 hours of
                    purchase. If applicable, cancellation charges will be
                    deducted, and the remaining amount will be refunded.
                  </p>
                </div>

                {/* RBI Statement */}
                <div
                  style={{
                    background: '#f8fafc',
                    borderRadius: '12px',
                    padding: '18px 20px',
                    borderLeft: '4px solid #198754',
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: '14px',
                      lineHeight: '1.7',
                      color: '#475467',
                      fontWeight: '500',
                    }}
                  >
                    All refunds and cancellations comply with RBI guidelines
                    for digital transactions.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Bottom Notice */}
        <Row style={{ marginTop: '30px' }}>
          <Col md={10} lg={9} className="mx-auto">
            <div
              style={{
                background: '#ffffff',
                border: '1px solid #e8ecf2',
                borderRadius: '14px',
                padding: '18px 22px',
                textAlign: 'center',
                color: '#667085',
                fontSize: '14px',
                boxShadow: '0 5px 20px rgba(16, 24, 40, 0.04)',
              }}
            >
              Please review the payment, refund and cancellation terms
              carefully before completing a transaction.
            </div>
          </Col>
        </Row>
      </Container>

      <Footer className="pt-0" />
    </div>
  );
};

export default PaymentC;